var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeacherSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 32,
    viewBox: "0 0 52 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_236_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0L25.5601 0.131038L7.99387 5.90774L4 7.20018L6.97297 8.18241V20.2517C5.48649 21.0777 5.78378 24 7.86486 24C9.94595 24 10.5405 21.3699 8.75676 20.2517V8.88299L11.947 9.78646V16.8556C11.947 17.9867 12.6496 18.9246 13.4844 19.5729C14.3191 20.2171 15.3562 20.6722 16.6013 21.0805C19.0943 21.8943 22.3799 22.373 26 22.373C29.6201 22.373 32.9057 21.8957 35.3987 21.0792C36.6438 20.6723 37.6809 20.2171 38.5156 19.5715C39.3504 18.9246 40.053 17.9867 40.053 16.8556V9.78646L44.0061 8.49263L48 7.20018L44.0047 5.90636L26.4385 0.131038L26 0ZM25.9864 2.0456L41.135 7.23274L25.9864 12.3873L10.8378 7.20018L25.9864 2.0456ZM14.7576 10.7354L25.5615 14.2693L26 14.399L26.4399 14.2679L37.8919 10.5355V16.657C37.8919 16.6708 37.4455 17.4825 37 17.826C36.5559 18.1708 35.5617 18.5384 34.5189 18.8805C32.4363 19.5605 29.3657 20.3881 26 20.3881C22.6343 20.3881 19.5637 19.5633 17.4797 18.8805C16.4397 18.5398 15.4441 18.1694 15 17.826C14.5531 17.4811 14.1081 16.6708 14.1081 16.657V10.5355L14.7576 10.7354Z",
    fill: "#3C789E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_236_40",
    x: 0,
    y: 0,
    width: 52,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_40"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_40",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherSmall);
export default __webpack_public_path__ + "static/media/teacherSmall.d04f8774234637421288f3a640536da1.svg";
export { ForwardRef as ReactComponent };